import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-simple-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent],
  templateUrl: './simple-layout.component.html',
  styleUrl: './simple-layout.component.scss',
})
export class SimpleLayoutComponent {
  constructor(private authService: AuthService) {}

  /** ログアウト */
  public logout() {
    this.authService.logout();
  }
}
